/*
 * Module for the Benefit Payroll YTD Report criteria page
 */
rs.module("content/reports/benefitpayrollytdcriteria",

    ["common/select-helper"],

    function (selectHelper) {

        function initialize(jsSelectors, sortOptions) {

            var criteria = $.js(jsSelectors.criteria);

            var summaryCheckbox = criteria.js(jsSelectors.summaryCheckbox);
            var sortSelect = criteria.js(jsSelectors.sortSelect);

            // Get Select Helper for _sortOptions selector since we're updating its options and properties
            var sortOptionsSelectHelper = selectHelper.getHelper(sortSelect);

            // run summaryOnlyChanged() on ready so page behaves correctly on initialize
            $(summaryOnlyChanged);

            // register checkbox change event
            summaryCheckbox.change(summaryOnlyChanged);

            // disable and 'clear' the sort options dropdown based on the status of Summary Only checkbox 
            function summaryOnlyChanged() {

                if (summaryCheckbox.is(":checked")) {
                    sortOptionsSelectHelper.clearOptions();
                    sortOptionsSelectHelper.setDisabled(true);
                }
                else {        
                    sortOptionsSelectHelper.setDisabled(false);
                    sortOptionsSelectHelper.replaceOptions(sortOptions);                                               
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);